import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal as AntModal, Button, Input, message, Select } from "antd";
import { CANCEL_TYPE } from "../../../../constants";
import { IconCheckLight } from "../../../../assets/icons";
import api from "../../../../api/api";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e1e1e;
  }

  .ant-modal-close svg {
    font-size: 24px;
  }

  .ant-select {
    margin: 16px 0;
    width: 100%;
  }

  .ant-input-affix-wrapper {
    margin-bottom: 16px;
  }

  .ant-modal-footer .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
`;

const RejectReasonModal = ({
  type = "all",
  id,
  p_id,
  product_id,
  variant_id,
  open,
  handleClose,
  successCallback,
}) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [cancel_type, setCancelType] = useState("");
  const [cancel_reason, setCancelReason] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);

  const {t} = useTranslation();

  const handleSubmitClicked = () => {
    if (
      !cancel_type ||
      (cancel_type === CANCEL_TYPE.OTHERS && !cancel_reason)
    ) {
      return;
    }

    if (!confirmLoading) {
      setConfirmLoading(true);

      const primary =
        cancel_type === CANCEL_TYPE.OTHERS
          ? cancel_reason
          : selectedOption?.fullData?.name?.primary || selectedOption?.label;

      const secondary =
        cancel_type === CANCEL_TYPE.OTHERS
          ? cancel_reason
          : selectedOption?.fullData?.name?.secondary || selectedOption?.label;

      const reason = primary;

      const payload = {
        id,
        cancel_reason: reason,
        cancellation_reason: {
          primary,
          secondary,
        },
      };

      if (type === "product") {
        payload.p_id = p_id;
        payload.variant_id = variant_id;
        payload.product_id = product_id;
      }

      api[type === "all" ? "cancelAllOrders" : "cancelOrderProduct"](payload)
        .then(() => {
          setConfirmLoading(false);
          message.success("Success!");
          handleClose();
          setCancelType("");
          successCallback(reason);
        })
        .catch((error) => {
          setConfirmLoading(false);
          message.error(error);
        });
    }
  };

  const getCancelReason = () => {
    api
      .getCancelReason()
      .then((res) => setOptions(res.data || []))
      .catch((err) => message.error(err));
  };

  useEffect(() => {
    getCancelReason();
  }, []);

  const opt = [
    ...(options
      ?.filter((option) => option?.type === "ADMIN")
      .map((option) => ({
        value: option?.name.primary,
        label: option?.name?.primary,
        fullData: option,
      })) ?? []),
    {
      value: CANCEL_TYPE.OTHERS,
      label: "Others",
    },
  ];

  return (
    <Modal
      centered
      open={open}
      onCancel={handleClose}
      title={t('order_cancel')}
      footer={
        <Button
          type="primary"
          icon={<IconCheckLight />}
          onClick={handleSubmitClicked}
          loading={confirmLoading}
          disabled={
            !cancel_type ||
            (cancel_type === CANCEL_TYPE.OTHERS && !cancel_reason)
          }
        >
          {t('submit')}
        </Button>
      }
    >
      <div>
        {t('cancel_order_text')}
      </div>
      <Select
        placeholder={t('choose_reason')}
        options={opt}
        onChange={(value, option) => {
          setCancelType(value);
          setSelectedOption(option);
        }}
        style={{ height: "fit-content" }}
      />
      {cancel_type === CANCEL_TYPE.OTHERS && (
        <Input.TextArea
          placeholder={t('write_reason')}
          maxLength={150}
          showCount
          onChange={(e) => setCancelReason(e.target.value)}
        />
      )}
    </Modal>
  );
};

export default RejectReasonModal;
